var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"video-gate"}},[_c('LoadingScreen',{attrs:{"progress":_vm.mediaLoadedPercent,"progressGate":_vm.percentGated}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }